module.exports = __webpack_public_path__ + "static/fipcsunshinerainbowsmain-d2e354d6eb22b2e6be491ff0218fd56f.jpeg";